module.exports = __webpack_public_path__ + "img/47.77f266a2.jpg";